import * as http from '@/model/http'
import {
  setHistory,
  setEntity,
  getCachedEntity,
  getAllEntities
} from '@/model/utils'
import { MyCompanyUser } from './schema'
import { FetchOptions } from '@/model/types'

const fetchUserSummaryByHash = async (args: {
  userHash: string
  options?: FetchOptions
}): Promise<MyCompanyUser | null> => {
  const url = `/users/summary?hash=${args.userHash}`
  const cached = getCachedEntity<MyCompanyUser>(
    'MyCompanyUserSummary',
    url,
    args.options
  )
  if (cached) return cached
  const { data }: { data: MyCompanyUser | null } = await http.get(url)
  if (!args?.options?.disableCache) {
    setHistory(url, [args.userHash], args.options)
    if (data) {
      setEntity('MyCompanyUserSummary', data, url)
    }
  }
  return data
}

const fetchMyCompanyUsers = async (args?: {
  options?: FetchOptions
}): Promise<MyCompanyUser[]> => {
  const url = '/my-company-users'
  const cached = getCachedEntity<MyCompanyUser[]>(
    'MyCompanyUser',
    url,
    args?.options
  )
  if (cached) return cached
  const { data }: { data: MyCompanyUser[] } = await http.get(url)
  // cache entity and history if needed
  if (!args?.options?.disableCache) {
    setHistory(
      url,
      data.map((item) => item.id.toString()),
      args?.options
    )
    data.forEach((item) => {
      setEntity('MyCompanyUser', item, item.id.toString())
    })
  }
  return data
}

const getMyCompanyUsers = (
  sort = 'lastMentionedAt'
): MyCompanyUser[] | undefined => {
  const entities = getAllEntities<MyCompanyUser>('MyCompanyUser')

  if (sort === 'lastMentionedAt') {
    return entities.sort((a, b) => {
      return (a.lastMentionedAt || '') > (b.lastMentionedAt || '') ? -1 : 1
    })
  }

  return entities
}

export default {
  fetchMyCompanyUsers,
  getMyCompanyUsers,
  fetchUserSummaryByHash
}
